import { useEffect } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { DepartmentDetailResponse } from 'api';
import { WorkFormCompanyInfo, WorkFormContext } from '../work-form.types';

export const useWorkFormDefaults = (
  defaultValues: Partial<WorkFormContext> | undefined,
  selectedCompany: WorkFormCompanyInfo | undefined,
  departmentData: DepartmentDetailResponse | undefined,
  setValue: UseFormSetValue<WorkFormContext>
) => {
  useEffect(() => {
    if (defaultValues) {
      if (defaultValues.companyOption) {
        setValue('companyOption', defaultValues.companyOption);
      }
      if (defaultValues.jobId) {
        setValue('jobId', defaultValues.jobId);
      }
      if (defaultValues.department) {
        setValue('department', defaultValues.department);
      }
      if (defaultValues.startDate) {
        setValue('startDate', defaultValues.startDate);
      }
      if (defaultValues.endDate) {
        setValue('endDate', defaultValues.endDate);
      }
      if (defaultValues.startTime) {
        setValue('startTime', defaultValues.startTime);
      }
      if (defaultValues.endTime) {
        setValue('endTime', defaultValues.endTime);
      }
      setValue('breakMinutes', defaultValues.breakMinutes);
      if (defaultValues.maxClaimants != null) {
        setValue('maxClaimants', defaultValues.maxClaimants);
      }
      setValue('hourlyRate', defaultValues.hourlyRate);
      setValue('mutableUntilHours', defaultValues.mutableUntilHours);
      setValue('cla', defaultValues.cla);
      setValue('jobType', defaultValues.jobType);
      setValue('location', defaultValues.location);
      setValue('contactName', defaultValues.contactName);
      setValue('contactPhoneWithPrefix', defaultValues.contactPhoneWithPrefix);
      setValue('imageUrl', defaultValues.imageUrl);
      setValue('vat', defaultValues.vat);
      setValue('isFlexPoolOnly', defaultValues.isFlexPoolOnly);
      setValue('shortDescription', defaultValues.shortDescription);
      setValue('longDescription', defaultValues.longDescription);
      setValue('descriptionLegalRequirements', defaultValues.descriptionLegalRequirements);
      setValue('jobCertificates', defaultValues.jobCertificates);
    }
  }, [
    defaultValues?.companyOption,
    defaultValues?.jobId,
    defaultValues?.department,
    defaultValues?.breakMinutes,
    defaultValues?.hourlyRate,
    defaultValues?.mutableUntilHours,
    defaultValues?.cla,
    defaultValues?.jobType,
    defaultValues?.location,
    defaultValues?.contactName,
    defaultValues?.contactPhoneWithPrefix,
    defaultValues?.vat,
    defaultValues?.flexPools,
    defaultValues?.isFlexPoolOnly,
    defaultValues?.shortDescription,
    defaultValues?.longDescription,
    defaultValues?.descriptionLegalRequirements,
    defaultValues?.jobCertificates,
    defaultValues?.imageUrl,
  ]);

  useEffect(() => {
    if (defaultValues == null || selectedCompany == null) {
      return;
    }
    setValue('isFreelance', defaultValues.isFreelance && selectedCompany.offersFreelanceWork);
    setValue('isTempwork', defaultValues.isTempwork && selectedCompany.offersTempWork);
    setValue('isEmployee', defaultValues.isEmployee && selectedCompany.offersEmployeeWork);
  }, [
    defaultValues?.isFreelance,
    defaultValues?.isTempwork,
    defaultValues?.isEmployee,
    selectedCompany,
  ]);

  useEffect(() => {
    if (defaultValues == null || departmentData == null) {
      return;
    }
    const flexPools = defaultValues.flexPools?.filter((flexpool) =>
      departmentData.department.flexPools.some((option) => option.id === flexpool.id)
    );
    setValue('flexPools', flexPools);
  }, [defaultValues?.flexPools, departmentData?.department.flexPools]);
};
